<div class="language-selector">
  <div class="language-selector__list">
    <button class="language-selector__list__language">
      <span *ngIf="currentLanguageIndex > 1">{{ languages[currentLanguageIndex - 2].nativeName }}</span>
    </button>
    <button class="language-selector__list__language">
      <span *ngIf="currentLanguageIndex > 0">{{ languages[currentLanguageIndex - 1].nativeName }}</span>
    </button>
    <button
      class="language-selector__list__language htv-selectable htv-focus"
      (click)="languageClicked(languages[currentLanguageIndex])">
      {{ languages[currentLanguageIndex].nativeName }}
    </button>
    <button class="language-selector__list__language">
      <span *ngIf="currentLanguageIndex < languages.length - 1">{{
        languages[currentLanguageIndex + 1].nativeName
      }}</span>
    </button>
    <button class="language-selector__list__language">
      <span *ngIf="currentLanguageIndex < languages.length - 2">{{
        languages[currentLanguageIndex + 2].nativeName
      }}</span>
    </button>
  </div>
</div>
